<template>
  <div>
    <div class="page-header">
      <div>
        <div class="page-title">系统设置</div>
        <div class="page-subtitle">角色权限与系统参数配置</div>
      </div>
      <el-button type="primary" plain @click="saveConfigs">保存设置</el-button>
    </div>
    <el-card>
      <el-form v-if="configs.length" label-width="140px" :model="formValues">
        <div v-for="group in configs" :key="group.title" class="settings-group">
          <div class="group-title">{{ group.title }}</div>
          <el-form-item v-for="child in group.children" :key="child.name" :label="child.label">
            <!-- 文本输入框 -->
            <el-input v-if="child.type === 'text'" v-model="formValues[child.name]" type="text" :placeholder="`请输入${child.label}`" />
            <!-- 文本域 -->
            <el-input v-else-if="child.type === 'textarea'" v-model="formValues[child.name]" type="textarea" :rows="3" :placeholder="`请输入${child.label}`" />
            <!-- 开关单选 -->
            <el-switch v-else-if="child.type === 'switch'" v-model="formValues[child.name]" active-color="#13ce66" inactive-color="#ff4949" />
            <!-- 默认输入框 -->
            <el-input v-else v-model="formValues[child.name]" type="text" :placeholder="`请输入${child.label}`" />
          </el-form-item>
        </div>
      </el-form>
      <div v-else class="settings-empty">暂无配置</div>
    </el-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      // 维护本地状态，避免直接修改props
      localGoods: [],
      configs: [],
      formValues: {}
    };
  },
  computed: {},
  mounted() { },
  created() {
    this.getConfigs()
  },
  methods: {
    getConfigs() {
      this.$http_get('/admin/settings/settings', 1).then(res => {
        if (res && res.code === 200 && Array.isArray(res.data)) {
          this.configs = res.data;
          res.data.forEach(group => {
            if (Array.isArray(group.children)) {
              group.children.forEach(child => {
                this.$set(this.formValues, child.name, child.value || "");
              });
            }
          });
        }
      })
    },
    saveConfigs() {
      const payload = Object.keys(this.formValues).map(name => ({
        name,
        value: this.formValues[name]
      }));
      this.$http_post('/admin/settings/save', payload, 1).then(() => { });
    }
  }
};
</script>

<style>
.settings-group {
  padding: 12px 0 4px;
  border-bottom: 1px solid #f0f0f0;
  margin-bottom: 12px;
}

.settings-group:last-child {
  border-bottom: 0;
  margin-bottom: 0;
}

.group-title {
  font-weight: 600;
  color: #303133;
  margin: 6px 0 10px;
}

.settings-empty {
  color: #909399;
  padding: 16px;
  text-align: center;
}
</style>
